import type { TeamChat } from '@/data/types';

// A group's or channel's name and description (Gary, 17 Oct). The same limits as the server
// (messaging-send team_info) and the table: names up to 60 characters, descriptions 500.
export const TEAM_NAME_MAX = 60;
export const TEAM_DESCRIPTION_MAX = 500;

/** Who may change them: any admin of a group, head office for a channel, nobody for a one-to-one chat or a Sentinel channel. */
export function canEditTeamInfo(chat: Pick<TeamChat, 'kind' | 'amAdmin' | 'system'>, headOffice: boolean): boolean {
  if (chat.system) return false; // Sentinel looks after Platform Health (Gary, 17 Oct)
  if (chat.kind === 'group') return chat.amAdmin === true;
  if (chat.kind === 'channel') return headOffice;
  return false;
}

/** A system line as the thread shows it: "You changed ..." or "Gary Harrod changed ...". */
export function systemLine(mine: boolean, senderName: string | undefined, body: string): string {
  return `${mine ? 'You' : senderName ?? 'A colleague'} ${body}`;
}

/** The lines a change writes, as the server does, for sample mode. */
export function infoChangeLines(kind: 'group' | 'channel', before: { name: string; description?: string }, name: string, description: string): string[] {
  const noun = kind === 'channel' ? 'channel' : 'group';
  const lines: string[] = [];
  if (name !== before.name) lines.push(`changed the ${noun} name to "${name}"`);
  if (description !== (before.description ?? '')) lines.push(description ? `changed the ${noun} description` : `removed the ${noun} description`);
  return lines;
}
